
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'HelpModal',
  components: {},
})
export default class HelpModal extends Vue {
  open(): void {
    $(this.$refs.modal!).modal('show');
  }

  dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
